export { V2_SYSTEM_PROMPT } from './systemPrompt';
export { ERROR_MESSAGES } from '../../AIChat/constants';

export const V2_STORAGE_KEY = 'cultwines_chat_v2_history';

export const V2_WELCOME_MESSAGES = [
  "Hello! I'm your Cult Wines portfolio assistant. I can help you understand your wine investments, analyze performance, and discover opportunities. What would you like to know?",
  'Welcome back! I can help you explore your portfolio, check on your wines, or find trading opportunities. How can I assist you today?',
  "Hi there! Ready to help you navigate your wine portfolio. Ask me about your performance, holdings, or any insights you'd like.",
];

export const V2_SUGGESTED_QUESTIONS = [
  'How is my portfolio performing?',
  'What are the top opportunities in my portfolio?',
  'Which wines should I consider selling?',
  'What wines are at peak maturity?',
  'How diversified is my portfolio?',
  "What's the overall risk assessment?",
  'Show me my regional allocation',
  'Do I have any active bids on my wines?',
];
